import { FaWhatsapp } from "react-icons/fa";

/**
 * FloatingWhatsApp
 * Always-visible floating WhatsApp chat button that opens the official
 * https://wa.me/ Click-to-Chat URL in a new tab.
 *
 * Props:
 *  - phoneNumber: string  Full number with country code, digits only
 *                         (no +, no spaces, no dashes). Default: "919884042552".
 *  - message:     string  Optional prefilled message.
 */
export default function FloatingWhatsApp({
  phoneNumber = "919884042552",
  message = "Hello! How can I help you today?",
}) {
  const handleClick = () => {
    const digits = String(phoneNumber).replace(/\D/g, "");
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${digits}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
      data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 w-16 h-16 rounded-full bg-[#25D366] text-white shadow-2xl flex items-center justify-center hover:scale-110 hover:bg-green-600 transition-all duration-300 z-[9999] cursor-pointer focus:outline-none focus-visible:ring-4 focus-visible:ring-green-300"
    >
      <FaWhatsapp className="w-8 h-8" />
    </button>
  );
}
